import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TestWrapper } from '../test-utils/test-wrapper';
import { RootState } from 'store/reducer';

const getTestComponent = (component: JSX.Element, state: Partial<RootState>) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <TestWrapper state={state}>{component}</TestWrapper>
    </QueryClientProvider>
  );
};

export default getTestComponent;
